<form *ngIf="workerSeizureFormGroup" [formGroup]="workerSeizureFormGroup">
    <div class="grid">
        <div class="col-6 input-field">
            <label for="isClosed">Estado</label>
            <p-dropdown [options]="status" formControlName="isClosed"  optionValue="value" id="isClosed"
                [filter]="true" filterBy="name" optionLabel="name" placeholder="Seleccione quén paga" appendTo="body"
                d-form-field-error />                                   
        </div> 
        <div class="col-6 input-field ">
            <label for="date">Fecha *</label>
            <p-calendar [firstDayOfWeek]="1" inputId="date" appendTo="body" dateFormat="dd/mm/yy" formControlName="date"
                d-form-field-error />
        </div>

        <div class="col-6 input-field">
            <label for="caseNumber">Nº embargo *</label>
            <input pInputText formControlName="caseNumber" style="field-sizing: content;" d-form-field-error />
        </div>
        <div class="col-12 input-field">
            <label for="name">Importe *</label>
            <input pInputText type="number" name="ammount" formControlName="ammount" d-form-field-error suffix=" €"/>
          </div>

        <div class="col-12 flex align-items-center">     
            <p-fileUpload mode="basic" accept=".doc,.docx,.pdf" chooseIcon="pi pi-upload" (onSelect)="onFileSelect($event)" [multiple]="false"  chooseLabel="Seleccionar documento de embargo" />
            <p-button *ngIf="workerSeizure.caseFile != null"  [link]="true"  (onClick)="downloadFile(workerSeizure.caseFileId)" > {{workerSeizure.caseFile.fileName}}&nbsp;<i class="pi pi-download"></i></p-button>
        </div>

        <div class="col-6 input-field " *ngIf="workerSeizureFormGroup.get('isClosed')?.value">
            <label for="closedDate">Fecha levantamiento de embargo *</label>
            <p-calendar [firstDayOfWeek]="1" inputId="date" appendTo="body" dateFormat="dd/mm/yy" formControlName="closedDate" id="closedDate"
                d-form-field-error />
        </div>

        <div class="col-12 flex align-items-center" *ngIf="workerSeizureFormGroup.get('isClosed')?.value">
            <p-fileUpload mode="basic" accept=".doc,.docx,.pdf" chooseIcon="pi pi-upload" (onSelect)="onFileSelect($event, false)" [multiple]="false"  chooseLabel="Seleccionar justificante del pago" />
            <p-button *ngIf="workerSeizure.closedCaseFile != null"  [link]="true"  (onClick)="downloadFile(workerSeizure.closedCaseFileId)" > {{workerSeizure.closedCaseFile.fileName}}&nbsp;<i class="pi pi-download"></i></p-button>
        </div>

        <div style="width: 100%;" *ngIf="workerSeizure.id">
            <div class="flex justify-content-end pb-1">
                <p-button label="Nuevo importe" (click)="editWorkersSeizureAmmounts(null)" styleClass="p-button-sm ml-2" *ngIf="allowWrite"></p-button>
            </div>
          <p-table styleClass="mt-2" #grid [value]="workersSeizureAmmounts" [paginator]="true" [rows]="25"
            [totalRecords]="totalWorkersSeizureAmmountsRecords" [showCurrentPageReport]="true"
            currentPageReportTemplate="Mostrando de {first} a {last} de un total de {totalRecords} entradas"
            [rowsPerPageOptions]="[25,100,250]" [scrollable]="true" scrollHeight="flex" paginatorDropdownAppendTo="body">
            <ng-template pTemplate="header" let-columns>
              <tr>
                <th pSortableColumn="date">Fecha <p-sortIcon field="date"></p-sortIcon></th>
                <th style="text-align: right;" pSortableColumn="ammount">Importe<p-sortIcon field="ammount"></p-sortIcon></th>
                <th width="100"></th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-ammounts let-columns="columns">
              <tr (dblclick)="editWorkersSeizureAmmounts(ammounts.id)">
                <td>{{ammounts.date | date: 'dd/MM/yyyy' }}</td>
                <td style="text-align: right;">
                    {{ammounts.ammount | currency: 'EUR'}}
                </td>
                <td>
                  <div class="flex gap-2 justify-content-end">
                    <p-button *ngIf="allowDelete" (click)="deleteWorkersSeizureAmmounts(ammounts.id)" [rounded]="true"
                      [text]="false" severity="danger"><i class="pi pi-trash"></i></p-button>
                    <p-button *ngIf="allowWrite" (click)="editWorkersSeizureAmmounts(ammounts.id)" [rounded]="true"
                      [text]="false"><i class="pi pi-pencil"></i></p-button>
                  </div>
                </td>
              </tr>
            </ng-template>
             <ng-template pTemplate="footer">
                <tr class="font-bold">
                    <td style="color: red">Pendiente: {{ workersSeizureAmmountsTotalRest | currency: 'EUR'}}</td>
                    <td style="text-align: right;">Total: {{workersSeizureAmmountsTotal | currency: 'EUR'}} </td>
                    <td></td>
                </tr>
            </ng-template>
          </p-table>
        </div>
        
    </div>

    <div class="mt-4 flex gap-2 justify-content-end">
        <p-button label="Eliminar" *ngIf="allowDelete && workerSeizure.id" icon="pi pi-trash"
            styleClass="p-button-danger" (click)="delete()"></p-button>
        <div class="flex-grow-1"></div>
        <p-button label="Cancelar" icon="pi pi-times" styleClass="p-button-secondary" (click)="cancel()"></p-button>
        <p-button label="Guardar" *ngIf="allowWrite" icon="pi pi-check" styleClass="p-ml-2" (click)="save()"></p-button>
    </div>

</form>